import { createSlice } from "@reduxjs/toolkit";
import { EDIT_COMMISSION } from "../constants";

export const commissionSlice = createSlice({
  name: EDIT_COMMISSION,
  initialState: {
    edit: false,
    currentIndex: 0,
    spr: 0,
    nkrate: 0,
    resellerRate: 0,
    totalRate: 0,
  },
  reducers: {
    commissionReducerSlice: (state, action) => {
      const data = {
        ...state,
        edit: action.payload.edit,
        currentIndex: action.payload.index,
      };

      return (state = data);
    },
    commissionEditReducerSlice: (state, action) => {
      const data = {
        ...state,
        spr: action.payload.spr,
        nkrate: action.payload.nkrate,
        resellerRate: action.payload.resellerRate,
        totalRate: action.payload.totalRate,
      };

      return (state = data);
    },
  },
});

export const { commissionReducerSlice, commissionEditReducerSlice } =
  commissionSlice.actions;

export default commissionSlice.reducer;
